export default ['extraNarrow', 'narrow', 'default', 'wide', 'extraWide'];
